import { __add__, __addGroup__ } from './db';

function add(tableName: string, data: FreeObjMap): any {
    return __add__(tableName, data);
}

function addGroup(tableName: string, dataList: Array<FreeObjMap>): any {
    return __addGroup__(tableName, dataList);
}

export {
    add,
    addGroup
};
